import { ModalNames } from "~/jsx/context/ModalNames";
import { XDesignModal } from "../design/XDesignModal";
import { useGame, useSessionUser } from "~/app";
import { XButton } from "../design";

export const XAuthorizeUndoModal = () => {
  const { update, undoState } = useGame();
  const { id: userId } = useSessionUser();
  const { answers, playerIds } = undoState;
  const answersLength = Object.values(answers).length;
  const needsAnswering =
    answersLength > 0 &&
    Object.entries(answersLength).every(([_, value]) => value === true) &&
    answersLength < playerIds.length &&
    answers[userId] === undefined;
  console.log(JSON.stringify(answers, null, 2));
  console.log({ answers, needsAnswering });

  const onAnswer = (isOk: boolean) => {
    update({
      methodName: "answerUndo",
      arg: {
        isOk,
      },
    });
  };

  return (
    <XDesignModal
      name={ModalNames.authorizeUndo}
      visible={needsAnswering}
      title={<>Do yo want to allow to cancel last action?</>}
    >
      <div
        style={{
          display: "flex",
          gap: 10,
          margin: "auto",
          width: "fit-content",
        }}
      >
        <XButton
          variant="action"
          onClick={() => onAnswer(true)}
          style={{ minWidth: 80, textAlign: "center" }}
        >
          Yes
        </XButton>
        <XButton
          variant="action"
          onClick={() => onAnswer(false)}
          style={{ minWidth: 80, textAlign: "center" }}
        >
          No
        </XButton>
      </div>
    </XDesignModal>
  );
};
